import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';

import { useUserStore } from '../../../../store/useUser';
import useHeader from '../../../../hooks/useHeader';

import { getAttendancesByMeetId, getAttendanceSummaryByMeetId } from '../../../../service/attendance';
import { getClubUser } from '../../../../service/clubUser';

import DefaultContainer from '../../../../components/DefaultContainer/DefaultContainer';
import AttendanceItem from '../AttendanceItem/AttendanceItem';

import { main_color, main_color_50 } from '../../../../styles/_variables';
import styles from './AttendancesList.module.scss';
import Icon from '../../../../components/Icon/Icon';
import { getMeetById } from '../../../../service/meet';
import { formatDateLocale } from '../../../../utils/formatDateLocale';
import { getBook } from '../../../../service/book';

const AttendancesList: React.FC = () => {
  const navigate = useNavigate()
  const { id, name: clubName, meetId : meet_id } = useParams();

  const clubId = Number(id);
  const meetId = Number(meet_id);
  
  const userId = useUserStore(state => state.id);
  const profile = useUserStore(state => state.profile);

  const { data: attendanceSummary, isFetching: isFetchingSummary } = useQuery(
    ['summary', meetId],
    () => getAttendanceSummaryByMeetId(meetId, clubId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const { data: meet, isFetching: isFetchingMeet } = useQuery(
    ['meet', meetId],
    () => getMeetById(meetId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const { data: book, isFetching: isFetchingBook } = useQuery(
    ['book', meet],
    () => {
      if (meet?.bookId) return getBook(meet?.bookId);
      return undefined;
    },
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const { data:clubUser, isFetching: isFetchingClubUser } = useQuery(
    ['clubUser', clubId],
    () => getClubUser(userId, clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const { data: attendances, isFetching: isFetchingAttendances } = useQuery(
    ['attendances', attendanceSummary],
    () => {
      if(attendanceSummary && attendanceSummary.totalMembers > 0)
        return getAttendancesByMeetId(meetId, clubId)
      return [];
    },
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const isAdminOrMediator = Boolean(clubUser?.isCreator === 1 || clubUser?.isMediator === 1);

  const isFetching = isFetchingClubUser || isFetchingSummary || isFetchingAttendances || isFetchingMeet || isFetchingBook;

  useHeader({ header: 'Lista de presenças' });

  if (attendanceSummary?.totalMembers === 0 || attendanceSummary?.totalMembers === null) navigate(`/club/${clubId}/${clubName}/attendances/meet/${meetId}/register`);
  if (!userId) return <DefaultContainer>Você precisa fazer login</DefaultContainer>;
  if((!isAdminOrMediator) || (profile === "Clubista")) return <DefaultContainer>Você não tem permissão pra vê essa página</DefaultContainer>;

  return (
      <div className={styles.header}>
        <div className={styles.titleHeader}>
          <Icon className={styles.icon} icon='calendar' color={main_color} />
          <span className={styles.name}>{formatDateLocale(meet?.dateMeet)}</span>
        </div>
        <div 
          className={styles.titleHeader}
          onClick={() => navigate(`/book/local/${meet?.bookId}`)}
        >
          <Icon className={styles.icon} icon='bookcase' color={main_color} />
          <span className={styles.name}>{book?.name} ({book?.author})</span>
        </div>
        <Spin spinning={isFetching}>
          {attendances?.map(item => 
              <AttendanceItem attendance={item} />
            )}
        </Spin>
      </div>
  )
}

export default AttendancesList;